import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Warning from "../components/Warning";
import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      enterTxt: "Enter",
      exForm: "",
      index: 2,
      sentences: ["######", "X##XXXX", "GXX##X", "WEB##X"],
    };
  }
  static defaultProps = {
    updateableText: "Submit",
    classButton: "",
  };
  async handleClick() {
    var data;
    var type;
    try {
      const response = await fetch(
        "https://api.csfrederick.com/data/" + this.state.inputValue,
        { mode: "cors" }
      );
      data = await response.json();
      type = 1;
    } catch (err) {
      try {
        const response = await fetch(
          "https://api.csfrederick.com/uuid/" + this.state.inputValue,
          { mode: "cors" }
        );
        data = await response.json();
        type = 2;
      } catch (err) {
        data = "ID doesn't exist!";
      }
    }
    if (data === "ID doesn't exist!") {
      this.setState({ enterTxt: "Try again", exForm: "Fail" });
    } else {
      if (type === 1) {
        window.location.href = "/photo?id=" + this.state.inputValue;
      } else {
        window.location.href = "/uuid?uuid=" + this.state.inputValue;
      }
    }
  }

  render() {
    return (
      <div className="App" style={{ margin: "-8px" }}>

        {/* ── Entrance & hover styles ── */}
        <style>{`
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(22px); }
            to   { opacity: 1; transform: translateY(0); }
          }
          @keyframes fadeIn {
            from { opacity: 0; }
            to   { opacity: 1; }
          }

          .resume-enter-title {
            animation: fadeUp 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
            animation-delay: 0.05s;
          }
          .resume-enter-buttons {
            animation: fadeUp 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
            animation-delay: 0.22s;
          }
          .resume-enter-frame {
            animation: fadeUp 0.85s cubic-bezier(0.22, 1, 0.36, 1) both;
            animation-delay: 0.4s;
          }

          /* Button hover — lift + glow intensify */
          .resume-btn {
            position: relative;
            transition: transform 0.22s cubic-bezier(0.22, 1, 0.36, 1),
                        box-shadow 0.22s ease,
                        opacity 0.2s ease !important;
          }
          .resume-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 24px rgba(160, 110, 255, 0.35) !important;
            opacity: 0.9;
          }
          .resume-btn:active {
            transform: translateY(0px);
          }

          /* iframe glow wrapper */
          .iframe-glow-wrapper {
            position: relative;
            border-radius: 14px;
          }
          .iframe-glow-wrapper::before {
            content: '';
            position: absolute;
            inset: -2px;
            border-radius: 16px;
            background: linear-gradient(135deg, rgba(160,110,255,0.45), rgba(100,70,220,0.2) 60%, transparent);
            z-index: 0;
            pointer-events: none;
          }
          .iframe-glow-wrapper::after {
            content: '';
            position: absolute;
            inset: -18px;
            border-radius: 24px;
            background: radial-gradient(ellipse at 50% 40%, rgba(150,100,255,0.22) 0%, transparent 70%);
            filter: blur(16px);
            z-index: -1;
            pointer-events: none;
          }
          .iframe-glow-wrapper iframe {
            position: relative;
            z-index: 1;
            display: block;
          }
        `}</style>

        <HelmetProvider>
          <Helmet>
            <title>Jack Frederick - Resume</title>
            <meta
              name="Jack Frederick - Resume"
              content="MST Student Seeking Computer Science"
              description="MST Student Seeking Computer Science"
              author="Jack Frederick"
            />
          </Helmet>
        </HelmetProvider>

        <Warning />
        <Navbar />

        <header className="Home">
          <p className="Homethick resume-enter-title">Resume</p>
          <br />

          {/* Buttons */}
          <div className="resume-enter-buttons" style={{ display: "flex", justifyContent: "center", gap: "12px", flexWrap: "wrap" }}>
            <a
              className="bold ats rightGap resume-btn"
              style={{ color: "black" }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://github.com/engineeringjack"
            >
              &nbsp;Check &nbsp;GitHub&nbsp;
            </a>
            <a
              className="bold ats rightGap resume-btn"
              style={{ color: "black" }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://drive.google.com/file/d/1julNVE7ZjhA6T0In159hhkkp9OLTliFO/view?usp=sharing"
            >
              ATS Friendly PDF
            </a>
            <a
              className="bold ats resume-btn"
              style={{ color: "black" }}
              href="/justvin"
            >
              JustVIN Policies
            </a>
          </div>

          <br />

          <div className="screenBox Minsize resume-enter-frame">
            <div className="iframe-glow-wrapper">
              <iframe
                src="/Resume.pdf"
                width="100%"
                height="1100px"
                style={{ border: "none", borderRadius: "12px" }}
                title="Resume"
              />
            </div>
            <br />
            <br />
            <br />
            <div className="photoSpacer"></div>
            <div className="photoSpacer"></div>
          </div>
        </header>

        <Footer />
      </div>
    );
  }

  updateInputValue(evt) {
    const val = evt.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    this.setState({ inputValue: val });
  }
}

export default App;